/* eslint-disable import/extensions */
/* eslint-disable jsx-a11y/label-has-associated-control */

import React, { useCallback, useEffect, useState } from 'react';
// 3rd Party Component goes here
import styled from 'styled-components';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { selectErrorLogin, selectLoading, selectUserData } from 'Selector/LoginSelector';
import { useDispatch, useSelector } from 'react-redux';
import { actions } from 'Slice/LoginSlice';
import { useSearchParams } from 'react-router-dom';
import {
  existsInCookies, getCookie, loginNavigation,
} from 'Utils/UtilityFunctions';
import OneSignalReact from 'react-onesignal';
import { User } from 'Types/LoginTypes';
import { LOGIN_ERROR_MESSAGES } from 'Utils/Constants';
import ValidationCodePopup from 'Components/auth/components/ValidationCodePopup';

import Button from '../components/Button';
import Checkbox from '../components/Checkbox';
import Input from '../components/Input';
// styles goes here
import '../assets/style.css';

import Message from '../components/Message';
import UserComponent from '../components/User';

interface Props {
  setRedirectPath: (url: string) => void;
}

const LoginWrapper = styled.div`
  margin: 0px;
  padding: 0px 60px;
  border-radius: 30px;
  background-color: #fff;
  display: block;
  width: 100%;
  @media all and (max-width: 1439px), all and (max-height: 749px) {
    padding: 0px 40px;
    border-radius: 21px;
    max-width: 350px;
  }
  h2 {
    color: #424b50;
    font-size: 32px;
    margin: 35px 0 10px 0;
    font-weight: 800;
    text-align: left;
    font-family: "Roboto Slab";
    @media all and (max-width: 1439px), all and (max-height: 749px) {
      font-size: 26px;
      margin: 25px 0 10px 0;
    }
  }
  .padding-right-password {
    padding-right: 2.2em !important;
  }
  label.remember-login {
    color: #7e7e7e;
    font-size: 16px;
    font-weight: 500;
    display: block;
    padding: 25px 0 30px 0;
    margin: 0px;
    font-family: "Roboto";
    line-height: 22px;
    display: inline-block;
    @media all and (max-width: 1439px), all and (max-height: 749px) {
      padding: 16px 0 16px 0;
      font-size: 12px;
    }
  }
  p {
    font-size: 16px;
    color: #5e7079;
    margin: 27px 0;
    font-family: "Roboto";
    font-weight: 600;
    @media all and (max-width: 1439px), all and (max-height: 749px) {
      margin: 16px 0;
      font-size: 12px;
    }
    a {
      color: #1ec252 !important;
      font-weight: 700;
      text-decoration: none;
    }
    .span {
      margin: 0px 5px;
      cursor: pointer;
      color: #1ec252 !important;
      font-weight: 700;
      text-decoration: none;
    }
  }
  button {
    display: block;
    cursor: pointer;
    @media all and (max-width: 1439px), all and (max-height: 749px) {
      font-size: 16px;
      padding: 8px 18px;
    }
  }
  label {
    @media all and (max-width: 1439px), all and (max-height: 749px) {
      margin: 16px 0 5px 0;
      font-size: 12px;
    }
  }
  input[type="text"],
  input[type="password"] {
    @media all and (max-width: 1439px), all and (max-height: 749px) {
      font-size: 16px;
      line-height: 20px;
      padding: 8px 18px;
      &.password + span {
        top: 13px;
      }
    }
  }
  .g-recaptcha > div {
    height: 85px !important;
    div > iframe {
      height: 85px !important;
    }
  }
`;

const LoginContainer: React.FC<Props> = function LoginContainer(props: Props) {
  const [username, setUsername] = useState<string>(getCookie('email') || '');
  const [password, setPassword] = useState<string>('');
  const [rememberMe, setRememberMe] = useState<boolean>(false);
  const [showInput, setShowInput] = useState<boolean>(false);
  const [loadNow, setLoadNow] = useState<boolean>(false);
  const [usernameError, setUsernameError] = useState<string>('');
  const [passwordError, setPasswordError] = useState<string>('');
  const [pushToken, setPushToken] = useState<string>('');
  const { setRedirectPath } = props;
  const loading: boolean = useSelector(selectLoading);
  const error: string = useSelector(selectErrorLogin);
  const userData: User | null = useSelector(selectUserData);
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const [showPassword, togglePassword] = useState(false);
  const { executeRecaptcha } = useGoogleReCaptcha();
  const [showValidationCodePopup, setShowValidationCodePopup] = useState(false);

  useEffect(() => {
    if (userData === null) return;
    if (userData && userData.active === 0) {
      setShowValidationCodePopup(true);
      return;
    }
    const url: string = searchParams.get('redirect-url') || '';
    loginNavigation(url);
  }, [userData]);

  useEffect(() => {
    OneSignalReact.getUserId((userId) => {
      setPushToken(userId || '');
    }).catch(() => { });
  }, [OneSignalReact]);

  useEffect(() => {
    setLoadNow(loading);
  }, [loading]);
  const getCapchaToken = useCallback(async () => {
    if (executeRecaptcha) {
      const capchaToken = await executeRecaptcha('Login');
      return capchaToken;
    }
    return null;
  }, [executeRecaptcha]);
  const handleSubmit = async () => {
    if (username === '') {
      setUsernameError(LOGIN_ERROR_MESSAGES.EMAIL_EMPTY);
    }
    if (password === '') {
      setPasswordError(LOGIN_ERROR_MESSAGES.PASSWORD_EMPTY);
    }
    if (username !== '' && password !== '') {
      if ((/\S+@\S+\.\S+/.test(username))) {
        setLoadNow(true);
        const recaptcha = await getCapchaToken();
        if (recaptcha) {
          const obj = {
            username,
            password,
            deviceToken: pushToken,
            recaptcha,
            rememberMe,
          };

          dispatch(actions.loginUser(obj));
        }
      } else {
        setUsernameError(LOGIN_ERROR_MESSAGES.INVALID_EMAIL);
      }
    }
  };
  const changeUsername = (e: React.ChangeEvent<HTMLInputElement>) => {
    setUsername(e.target.value);
    if (usernameError !== '') {
      setUsernameError('');
    }
  };
  const changePassword = (e: React.ChangeEvent<HTMLInputElement>) => {
    setPassword(e.target.value);
    if (passwordError !== '') setPasswordError('');
  };
  const showInputHelper = () => showInput === false && (existsInCookies('userName') && existsInCookies('email'));

  const onVerificationCodeSuccess = () => {
    loginNavigation();
    setShowValidationCodePopup(false);
  };
  const closePopup = () => {
    setShowValidationCodePopup(false);
  };

  return (
    <>
      <LoginWrapper>
        <h2>Login</h2>
        {error !== '' && (
          <Message
            type="error"
            label="Error!"
            message={error}
            marginBottom=""
          />
        )}
        {
          showInputHelper() ? (
            <UserComponent
              label={getCookie('userName') || ''}
              pic={getCookie('image') || ''}
              onClick={() => {
                setUsername('');
                setShowInput(true);
              }}
            />
          ) : (
            <Input
              inputValue={username}
              inputClassName=""
              inputName="email"
              inputType="text"
              inputLabel="Email"
              error={usernameError}
              inputPlaceholder="Enter your email address…"
              onInputChange={changeUsername}
            />
          )
        }

        <Input
          inputValue={password}
          inputClassName="password padding-right-password"
          isPassword
          inputName="Password"
          error={passwordError}
          inputLabel="Password"
          inputType={showPassword ? 'text' : 'password'}
          inputPlaceholder="Enter your password…"
          onInputTogglePassword={() => togglePassword(!showPassword)}
          onInputChange={changePassword}
        />
        <label className="remember-login">
          <Checkbox
            checked={rememberMe}
            onChangeCheckBox={(e) => setRememberMe(e.target.checked)}
          />
          Remember me next time I log in
        </label>
        <Button value={loadNow ? 'Loading...' : 'Log in now'} isDisabled={loadNow} onClickButton={handleSubmit} />
        <p>
          Did you forget your
          <span
            className="span"
            onClick={() => setRedirectPath('username')}
            onKeyPress={() => setRedirectPath('username')}
            role="button"
            aria-label="Username"
            tabIndex={0}
          >
            username
          </span>
          or
          <span
            className="span me-0 mr-0"
            onClick={() => setRedirectPath('password')}
            onKeyPress={() => setRedirectPath('username')}
            role="button"
            aria-label="password"
            tabIndex={0}
          >
            password

          </span>
          ?
        </p>
      </LoginWrapper>
      {
        showValidationCodePopup ? (
          <ValidationCodePopup
            onVerificationCodeSuccess={onVerificationCodeSuccess}
            onClosePopup={closePopup}
            username={username}
          />
        ) : null
      }
    </>
  );
};

export default LoginContainer;
